import Text from '@csc/dls/Text'
import Row from '@csc/dls/Row'

export const BrandDescription: React.FC<{
  brand_description_title: string
  brand_description: string
}> = ({
  brand_description_title,
  brand_description,
}) => (
  <Row cols={1}>
    <Text size="xl" bold className="mt-4 pt-2">
      {brand_description_title}
    </Text>
    <Text size="md" className="text-primary">
      {brand_description}
    </Text>
  </Row>
)

export default BrandDescription
